var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'coupon-applied': _vm.couponMessage }},[(_vm.couponMessage)?_c('div',{staticClass:"message"},[_c('p',[_vm._v(_vm._s(_vm.couponMessage))])]):_vm._e(),_c('div',{staticClass:"login-container"},[_c('SignupWizard')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }